"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalDetailApprovals = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _models = require("../models");
var _utils = require("../utils");
var _SharedStyledComponents = require("./SharedStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const CollapseBox = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  fontWeight: 'bold',
  cursor: 'pointer',
  marginBottom: theme.spacing(3)
}));
const LegalDetailApprovals = props => {
  const {
    config
  } = props;
  const [showApprovals, setShowApprovals] = (0, _react.useState)(false);
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const form = (0, _reactHookForm.useFormContext)();
  const {
    isSubmitting
  } = form.formState;
  const approvalValues = form.watch().legalDetails;
  const isNegativeApprovals = config?.approvals?.shared?.displayAsNegative;
  const sectionOrder = (0, _utils.getLowestDisplayOrder)(config?.approvals);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledGridItem, {
    size: {
      xs: 12
    },
    style: {
      order: sectionOrder ?? undefined
    },
    children: [isNegativeApprovals ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(CollapseBox, {
      onClick: () => setShowApprovals(!showApprovals),
      children: [showApprovals ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.Legal_ShowLess,
        id: _models.TranslationKey.Legal_ShowLess
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.Legal_ShowMore,
        id: _models.TranslationKey.Legal_ShowMore
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
        sx: {
          transform: showApprovals ? 'rotateX(180deg)' : '0',
          transition: 'all 0.2s ease-in-out'
        }
      })]
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Collapse, {
      in: isNegativeApprovals ? showApprovals : true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.isReseller.value",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.isReseller ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Reseller,
            id: _models.TranslationKey.Legal_Reseller
          })
        }),
        value: approvalValues?.isReseller?.value,
        ...config?.isReseller,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.contact",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.contact ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_Contact,
            id: _models.TranslationKey.Legal_Approval_Contact
          })
        }),
        value: approvalValues?.approvals?.contact,
        ...config?.approvals?.contact,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.blockGuaranteeOrdering",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.blockGuaranteeOrdering ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_BlockGuaranteeOrdering,
            id: _models.TranslationKey.Legal_Approval_BlockGuaranteeOrdering
          })
        }),
        value: approvalValues?.approvals?.blockGuaranteeOrdering,
        ...config?.approvals?.blockGuaranteeOrdering,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.marketingConsultant",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.marketingConsultant ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_MarketingConsultant,
            id: _models.TranslationKey.Legal_Approval_MarketingConsultant
          })
        }),
        value: approvalValues?.approvals?.marketingConsultant,
        ...config?.approvals?.marketingConsultant,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.marketingExternal",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.marketingExternal ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_MarketingExternal,
            id: _models.TranslationKey.Legal_Approval_MarketingExternal
          })
        }),
        value: approvalValues?.approvals?.marketingExternal,
        ...config?.approvals?.marketingExternal,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.marketingOriflame",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.marketingOriflame ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_MarketingOriflame,
            id: _models.TranslationKey.Legal_Approval_MarketingOriflame
          })
        }),
        value: approvalValues?.approvals?.marketingOriflame,
        ...config?.approvals?.marketingOriflame,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.newsletters",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.newsletters ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_Newletters,
            id: _models.TranslationKey.Legal_Approval_Newletters
          })
        }),
        value: approvalValues?.approvals?.newsletters,
        ...config?.approvals?.newsletters,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.optedOutOfSponsorSelect",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.optedOutOfSponsorSelect ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_optedOutOfSponsorSelect,
            id: _models.TranslationKey.Legal_Approval_optedOutOfSponsorSelect
          })
        }),
        value: approvalValues?.approvals?.optedOutOfSponsorSelect,
        ...config?.approvals?.optedOutOfSponsorSelect,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.orderHistory",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.orderHistory ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_orderHistory,
            id: _models.TranslationKey.Legal_Approval_orderHistory
          })
        }),
        value: approvalValues?.approvals?.orderHistory,
        ...config?.approvals?.orderHistory,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.personalData",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.personalData ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_PersonalData,
            id: _models.TranslationKey.Legal_Approval_PersonalData
          })
        }),
        value: approvalValues?.approvals?.personalData,
        ...config?.approvals?.personalData,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.publication",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.publication ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_Publication,
            id: _models.TranslationKey.Legal_Approval_Publication
          })
        }),
        value: approvalValues?.approvals?.publication,
        ...config?.approvals?.publication,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.uplineLeaderBrowse",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.uplineLeaderBrowse ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_UplineLeaderBrowse,
            id: _models.TranslationKey.Legal_Approval_UplineLeaderBrowse
          })
        }),
        value: approvalValues?.approvals?.uplineLeaderBrowse,
        ...config?.approvals?.uplineLeaderBrowse,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        name: "legalDetails.approvals.uplineLeaderData",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          sx: {
            fontWeight: approvalValues?.approvals?.uplineLeaderData ? 'bold' : 'normal'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Legal_Approval_UplineLeaderData,
            id: _models.TranslationKey.Legal_Approval_UplineLeaderData
          })
        }),
        value: approvalValues?.approvals?.uplineLeaderData,
        ...config?.approvals?.uplineLeaderData,
        isSubmitting: isSubmitting,
        customErrors: customErrors
      })]
    })]
  });
};
exports.LegalDetailApprovals = LegalDetailApprovals;
